export default  [
    {
      id: '1',
      icon: '',
      symbol: 'TokenB',
      name: 'TokenB',
      decimals: '9',
      address: '0x2C73b820913A76E64aaAefD7edbBCc2dfe8ffF8d',
      exchange_rate: '300%',
      vesting_period: '2 Days',
      explorer: 'https://testnet.snowtrace.io/',
      network: "Avalanche-fuji"
    },
    {
      id: '2',
      icon: '',
      symbol: 'TokenC',
      name: 'TokenC',
      decimals: '9',
      address: '0x66E64230bA6b7704Fe3bE1D7FB1b7e8E059F82cd',
      exchange_rate: '300%',
      vesting_period: '5 Days',
      explorer: 'https://testnet.snowtrace.io/',
      network: "Avalanche-fuji"
    },
    {
      id: '3',
      icon: '',
      symbol: 'TokenD',
      name: 'TokenD',
      decimals: '18',
      address: '0x882b4Ed3aA14159B61F1c7b1756B1e312B235A7B',
      exchange_rate: '300%',
      vesting_period: '1 Month',
      explorer: 'https://testnet.snowtrace.io/',
      network: "Avalanche-fuji"
    },
    {
      id: '4',
      icon: '',
      symbol: 'TokenE',
      name: 'TokenE',
      decimals: '18',
      address: '0xfC5837528646E03E8927A33C1794435aBaddCF52',
      exchange_rate: '300%',
      vesting_period: '3 Hours',
      explorer: 'https://testnet.snowtrace.io/',
      network: "Avalanche-fuji"
    },
  ];
  